/**
 * Series Types
 * Recording series is the parent entity for episodes
 */

export type SeriesType = 'podcast' | 'channel' | 'show';

export interface Series {
  id: string;
  team_id: string;
  name: string;
  description: string | null;
  series_type: SeriesType;
  cover_image_url: string | null;
  production_lead_days: number;
  recording_to_release_days: number;
  created_at: string;
  updated_at: string;
}

export interface SeriesWithCount extends Series {
  episode_count: number;
}

export interface CreateSeriesInput {
  team_id: string;
  name: string;
  description?: string;
  series_type?: SeriesType;
  cover_image_url?: string;
  production_lead_days?: number;
  recording_to_release_days?: number;
}

export interface UpdateSeriesInput {
  name?: string;
  description?: string;
  series_type?: SeriesType;
  cover_image_url?: string;
  production_lead_days?: number;
  recording_to_release_days?: number;
}

export const SERIES_TYPE_LABELS: Record<SeriesType, string> = {
  podcast: 'Podcast',
  channel: 'Channel',
  show: 'Show',
};

export const SERIES_TYPE_DESCRIPTIONS: Record<SeriesType, string> = {
  podcast: 'Audio or video podcast series',
  channel: 'YouTube or streaming channel',
  show: 'TV or web show series',
};
